import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import "../../css/ContactUs.css";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../designSystem/PrimaryButton";
import { ReactComponent as PhoneIcon } from "../../assets/icons/call.svg";
import { ReactComponent as EmailIcon } from "../../assets/icons/email.svg";
import CustomSelect from "../designSystem/CustomSelect";

const enquiryOptions = [
  //   { id: "", label: "Request a Consultation" },
  { id: "Request a Consultation", label: "Request a Consultation" },
  { id: "General Enquiry", label: "General enquiry" },
  { id: "Quote", label: "Quote" },
  { id: "Renew Cover", label: "Renew cover" },
  { id: "Make a Claim", label: "Make a claim" },
  { id: "Sign Up for Newsletter", label: "Sign Up for Newsletter" },
];

const ContactUs = () => {
  const [form, setForm] = useState({
    name: "",
    number: "",
    email: "",
    message: "",
    consent: false,
  });

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const isSchoolPage = location.pathname === "/for-schools";

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // clear field error as user types
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const next = {};

    if (!form.name.trim()) next.name = "Name is required";
    if (!form.number.trim()) next.number = "Number is required";
    if (!form.email.trim()) next.email = "Email is required";
    if (!form.message.trim()) next.message = "Message is required";
    if (!form.consent)
      next.consent = "Please confirm you have read the privacy policy";

    setErrors(next);
    return Object.keys(next).length === 0;
  };

  // console.log("API URL:", process.env.REACT_APP_SERVER_URL);

  /**
   * Runs automatically on Google Form submit (installable trigger).
   * Sends the form response to your Node endpoint.
   */
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!validate()) return;

      const to = process.env.REACT_APP_ADVISER_EMAIL;

      const payload = {
        name: form.name.trim(),
        email: form.email.trim(),
        number: form.number.trim(),
        message: form.message.trim(),
        to: (to || "").trim(),
      };

      const url = `${process.env.REACT_APP_SERVER_URL}/send-adviser-contact-confirmation`;

      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errText = await res.text();
        console.log("API error:", errText);
        return;
      }

      // optional: success UI / reset
      setForm({
        name: "",
        number: "",
        email: "",
        message: "",
        consent: false,
      });

      setErrors({});
      console.log("Sent successfully");
    } catch (err) {
      console.log("handleSubmit error:", err);
    }
  };

  return (
    <>
      {/*  CONTACT FORM */}
      <section
        section
        className="plan section-bg section-bg--blue"
        id="contact"
      >
        <div className="why-choose-us__container ">
          <h4>CONTACT US</h4>
          <div className="divider"></div>
          <div className="content align-left">
            We provide materials to help you explore your options, meet families
            at school open days, and offer an easy link online so you can access
            information whenever you need it. We also share helpful insights in
            school newsletters, and manage all ongoing communication directly
            with you.
          </div>

          <div className="content align-left">
            {isSchoolPage
              ? "Contact us to find out how we can work together."
              : "Get in touch to find out more and see how we can support your family."}
          </div>
          <div className="contact-us-row" style={{ padding: "20px 0px" }}>
            <div
              className="why-choose-us__container "
              style={{ padding: "0px" }}
            >
              <div className="content-medium">
                Matthew Edwards
                <div className="content align-left">Founder & CEO</div>
              </div>
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <PhoneIcon />
                </div>
                <div className="footer-contact-details">
                  <a href="tel:+443302237717" className="content">
                    0330 223 7717
                  </a>
                </div>
              </div>
              <div className="footer-contact-item">
                <div className="footer-contact-icon">
                  <EmailIcon />
                </div>
                <div className="footer-contact-details">
                  <a
                    href="mailto:enquiries@feeprotectionplan.co.uk"
                    className="content"
                  >
                    enquiries@feeprotectionplan.co.uk
                  </a>
                </div>
              </div>
            </div>
            <>
              <form className="contact-form" onSubmit={handleSubmit}>
                {/* <h2>Send Us A Message</h2>
              <div
                className="divider align-center"
                style={{ width: "100%" }}
              ></div> */}
                <div className="contact-row">
                  <div className="contact-field">
                    {/* <label className="content-small">Name:</label> */}
                    <input
                      name="name"
                      placeholder="Name:"
                      value={form.name}
                      onChange={handleChange}
                      className={`${errors.name ? "has-error" : ""} help-text`}
                    />
                    {errors.name ? (
                      <span className="error-text">{errors.name}</span>
                    ) : null}
                  </div>

                  <div className="contact-field">
                    {/* <label className="content-small">Number:</label> */}
                    <input
                      name="number"
                      placeholder="Phone Number:"
                      value={form.number}
                      onChange={handleChange}
                      className={`${errors.number ? "has-error" : ""} help-text`}
                    />
                    {errors.number ? (
                      <span className="error-text">{errors.number}</span>
                    ) : null}
                  </div>
                </div>

                <div className="contact-field">
                  {/* <label className="content-small">Email:</label> */}
                  <input
                    name="email"
                    placeholder="Email:"
                    value={form.email}
                    onChange={handleChange}
                    className={`${errors.email ? "has-error" : ""} help-text`}
                  />
                  {errors.email ? (
                    <span className="error-text">{errors.email}</span>
                  ) : null}
                </div>

                <div className="contact-field">
                  {/* <label className="content-small">Type of enquiry:</label> */}
                  <CustomSelect
                    options={enquiryOptions}
                    value={form.message}
                    onChange={(e) => {
                      setForm((prev) => ({
                        ...prev,
                        message: e.target.value,
                      }));
                      setErrors((prev) => ({ ...prev, message: "" }));
                    }}
                    placeholder="Type of enquiry:"
                    error={!!errors.message}
                  />
                  {errors.message ? (
                    <span className="error-text">{errors.message}</span>
                  ) : null}
                </div>

                <div className="contact-consent">
                  <input
                    type="checkbox"
                    name="consent"
                    checked={form.consent}
                    onChange={handleChange}
                    id="consent"
                  />
                  <label htmlFor="consent" className="help-text-regular">
                    <span style={{ color: "#d04444" }}>*</span>I confirm I have
                    read the{" "}
                    <span
                      // href="/privacy-policy"
                      // target="_blank"
                      // rel="noopener noreferrer"
                      style={{
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate("/privacy-policy")}
                    >
                      privacy policy
                    </span>
                  </label>
                  {errors.consent ? (
                    <span className="error-text">{errors.consent}</span>
                  ) : null}
                </div>
                <PrimaryButton text="Submit" type="submit" variant="outlined">
                  <div className="button-text">Submit</div>
                </PrimaryButton>
              </form>
            </>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
